import { useQuery } from "@tanstack/react-query";
import { engineError } from "@/lib/engine-error";
import type { CompanySummary } from "@/lib/profitability-api";

export function useSummary(range?: string, contractType?: string) {
  return useQuery({
    queryKey: ["summary", range ?? "default", contractType ?? "all"],
    queryFn: async (): Promise<CompanySummary> => {
      const params = new URLSearchParams();
      if (range) params.set("range", range);
      if (contractType && contractType !== "all") params.set("contract_type", contractType);
      const qs = params.toString();
      const response = await fetch(`/api/summary${qs ? `?${qs}` : ""}`);
      if (!response.ok) {
        throw await engineError(response, "Could not load the summary");
      }
      return response.json();
    },
    // Month-end close data; it changes once a month.
    staleTime: 5 * 60 * 1000,
  });
}
